module.exports = __webpack_public_path__ + "img/n_pg2.85632128.png";